module.exports = __webpack_public_path__ + "img/floor-AI.0cfb5af9.png";